import { Component, input, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { BreadcrumbService } from '../../services/breadcrumb.service';

export interface BreadcrumbItem {
  label: string;
  url?: string;
}

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [CommonModule, RouterModule, MatIconModule, TranslatePipe],
  templateUrl: './breadcrumb.component.html',
  styleUrl: './breadcrumb.component.scss',
})
export class BreadcrumbComponent {
  private readonly breadcrumbService = inject(BreadcrumbService);

  /** Items to display (last item is current page, no link). Si no se pasa, se usan los del BreadcrumbService desde la ruta. */
  items = input<BreadcrumbItem[]>();

  /** Items efectivos: input si existe, si no los del servicio. */
  effectiveItems = computed(() => this.items() ?? this.breadcrumbService.breadcrumbItems());
}
